module.exports = __webpack_public_path__ + "img/编组 1.1e0b299a.png";